import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Routes, Route, Navigate } from 'react-router-dom';

import { AdminProviders } from './providers/AdminProviders';
import { LoginPage } from './pages/LoginPage';
import { AdminLayout } from './components/AdminLayout';
import { AuthGuard } from './components/AuthGuard';
import { ConnectorPage } from './components/ConnectorPage';
import { UsersPage } from './pages/UsersPage';
import { readAuthConnectors } from './contexts/ConnectorContext';

function DefaultRedirect() {
    const connectors = readAuthConnectors();
    if (connectors.length === 0) {
        return <Navigate to="/utilisateurs" replace />;
    }
    return <Navigate to={`/${connectors[0].slug}/marge-brute`} replace />;
}

function App() {
    return (
        <AdminProviders>
            <Routes>
                <Route path="/login" element={<LoginPage />} />
                <Route
                    path="/*"
                    element={
                        <AuthGuard>
                            <AdminLayout>
                                <Routes>
                                    <Route path="/utilisateurs" element={<UsersPage />} />
                                    <Route path="/:connectorSlug/*" element={<ConnectorPage />} />
                                    <Route path="*" element={<DefaultRedirect />} />
                                </Routes>
                            </AdminLayout>
                        </AuthGuard>
                    }
                />
            </Routes>
        </AdminProviders>
    );
}

const container = document.getElementById('app');
if (container) {
    createRoot(container).render(
        <StrictMode>
            <App />
        </StrictMode>,
    );
}
